module.exports = __webpack_public_path__ + "img/store-fill.9cc1cff2.svg";